import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import { TinymceEditorComponent } from '../tinymce-editor/tinymce-editor.component'
import Swal from 'sweetalert2'

@Component({
	selector: 'refactor-text',
	templateUrl: './refactor-text.component.html',
	styleUrls: ['./refactor-text.component.scss']
})

export class RefactorTextComponent implements OnInit, AfterViewInit, OnDestroy {

	userID = 0
	courseID = 0
	textAction = ''

	textSource = ''
	courseUnits: any[] = []
	selectedUnit = -1
	unitLessons: any[] = []
	selectedLesson = -1
	lessonHeadings: any[] = []
	selectedHeading = -1
	text = '¿Qué es la inteligencia artificial? La inteligencia artificial es la habilidad de una máquina de presentar las mismas capacidades que los seres humanos, como el razonamiento, el aprendizaje, la creatividad y la capacidad de planear. La IA permite que los sistemas tecnológicos perciban su entorno, se relacionen con él, resuelvan problemas y actúen con un fin específico. La máquina recibe datos(ya preparados o recopilados a través de sus propios sensores, por ejemplo, una cámara), los procesa y responde a ellos. Los sistemas de IA son capaces de adaptar su comportamiento en cierta medida, analizar los efectos de acciones previas y de trabajar de manera autónoma.'
	sentenceRatio = 0
	numWords = 0
	maxLength = 100

	refactoringText = false
	refactorTextSuccess = false
	refactorTextError = false
	refactorTextBtnDisabled = true
	refactorResultMsg = ''
	refactoredTextOption1 = ''
	refactoredTextOption2 = ''
	refactoredTextOption3 = ''
	refactoredTextOption4 = ''
	refactoredText = ''

	updatingHeading = false
	updateHeadingSuccess = false
	updateHeadingError = false
	updateHeadingBtnDisabled = true

	showCourseSub = new Subscription
	summarizeTextSub = new Subscription
	paraphraseTextSub = new Subscription
	taskStatusCelerySub = new Subscription
	updateHeadingSub = new Subscription

	@ViewChild(TinymceEditorComponent) tinymceEditorDiv: any
	headingTextEditorId = 'heading-text-editor'
	textSourceEditorId = 'text-source-editor'
	refactoredTextEditorId = 'refactored-text-editor'

	constructor(private dataService: ApiService, private route: ActivatedRoute) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
		this.courseID = +this.route.snapshot.paramMap.get('id')!
		this.tinymceEditorDiv = new TinymceEditorComponent(this.dataService)
	}

	ngAfterViewInit(): void {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units
			},
			error => {
				console.log(error)
			},
		)
	}

	ngOnDestroy(): void {
		this.showCourseSub?.unsubscribe()
		this.summarizeTextSub?.unsubscribe()
		this.paraphraseTextSub?.unsubscribe()
		this.taskStatusCelerySub?.unsubscribe()
		this.updateHeadingSub?.unsubscribe()
	}

	selectUnit(unitId: number): void {
		console.log(unitId)
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id
		})?.lessons!
		console.log(this.unitLessons)
		
		this.selectedLesson = -1
		this.selectedHeading = -1
		this.lessonHeadings = []
		this.refactorTextBtnDisabled = true

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id)
		}
	}

	selectLesson(lessonId: number): void {
		this.lessonHeadings = this.unitLessons?.find((lesson) => {
			return +lessonId === +lesson.id
		})?.headings!
		
		this.selectedLesson = +lessonId
		this.selectedHeading = -1
		this.refactorTextBtnDisabled = true
		
		if (this.lessonHeadings?.length === 1) {
			this.selectHeading(this.lessonHeadings[0].id)
		}
	}

	selectHeading(headingId: number): void {
		this.refactorTextBtnDisabled = false
		this.selectedHeading = +headingId

		this.dataService.showHeading(headingId)
		.subscribe(
			heading => {
				this.text = heading.content?.trim()
			},
			error => {
				console.log(error)
			},
		)
	}

	resetUnits() {
		this.selectedUnit = -1
		this.selectedLesson = -1
		this.selectedHeading = -1
		this.unitLessons = []
		this.lessonHeadings = []
	}

	refactorTextSetLoading() {
		this.refactorTextBtnDisabled = true
		this.refactoringText = true
		this.refactorTextError = false
		this.refactorTextSuccess = false
	}
	
	refactorTextSetError() {
		this.refactorTextBtnDisabled = false
		this.refactoringText = false
		this.refactorTextError = true
		this.refactorTextSuccess = false
	}
	
	refactorTextSetSuccess() {
		this.refactorTextBtnDisabled = false
		this.refactoringText = false
		this.refactorTextError = false
		this.refactorTextSuccess = true
	}

	summarizeText(): void {
		// console.log(this.text)
		// console.log(this.sentenceRatio)
		// console.log(this.numWords)
		
		let editorId = ''
		let heading = 0
		if (this.textSource === 'heading') {
			editorId = this.headingTextEditorId
			heading = this.selectedHeading
		} else if (this.textSource === 'text') {
			editorId = this.textSourceEditorId
			heading = 0
		}
		
		this.text = this.tinymceEditorDiv.getEditorContent(editorId)
		if (!this.text) {
			Swal.fire('Error', 'Por favor, escriba algo en la caja de texto.', 'error')
			return
		}

		if (!this.sentenceRatio && !this.numWords) {
			Swal.fire('Error', 'Uno de los dos valores debe ser mayor a 0.', 'error')
			return
		}

		this.refactorTextSetLoading()
		
		this.summarizeTextSub = this.dataService.summarizeText(this.text, this.sentenceRatio, this.numWords, heading)
		.subscribe(
			data => {
				console.log(data)
				let task = data.id

				let interval = 1000 * 60 * 0.07
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('summary', task)
					.subscribe(
						data => {
							console.log(data)
							let status = data.status

							if (status === "SUCCESS") {
								this.refactorTextSetSuccess()
								window.clearTimeout(idinterval)

								this.refactorResultMsg = data.result.message
								this.refactoredText = data.result.abstract

								if (this.textSource === 'heading') this.updateHeadingBtnDisabled = false
							}

						},
						error => {
							console.log(error)
							window.clearTimeout(idinterval)
							this.refactorTextSetError()
						},
					)
				}, interval)
			},
			error => {
				console.log(error)
				this.refactorTextSetError()
			},
		)
	}

	paraphraseText(): void {
		// console.log(this.text)
		// console.log(this.maxLength)

		let editorId = ''
		let heading = 0
		if (this.textSource === 'heading') {
			editorId = this.headingTextEditorId
			heading = this.selectedHeading
		} else if (this.textSource === 'text') {
			editorId = this.textSourceEditorId
			heading = 0
		}

		this.text = this.tinymceEditorDiv.getEditorContent(editorId)
		if (this.text.length === 0) {
			Swal.fire('Error', 'Por favor, escriba algo en la caja de texto.', 'error')
			return
		}

		if (this.maxLength < 100) {
			Swal.fire('Error', 'El valor de caracteres máximos debe ser igual o mayor a 100.', 'error')
			return
		}

		this.refactorTextSetLoading()
		
		this.paraphraseTextSub = this.dataService.paraphraseText(this.text, this.maxLength, heading)
		.subscribe(
			data => {
				console.log(data)
				let task = data.id

				let minutes = 1
				let interval = 1000 * 60 * minutes
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('paraphraser', task)
					.subscribe(
						data => {
							console.log(data)
							let status = data.status

							if (status != "PENDING" && status != "STARTED") {
								window.clearTimeout(idinterval)
							}

							if (status === "SUCCESS") {
								this.refactorResultMsg = data.result.message
								let paraphraseResult = data.result.data.paraphrase

								paraphraseResult.forEach((elem: any) => {
									this.refactoredTextOption1 += `${elem.option1} `
									this.refactoredTextOption2 += `${elem.option2} `
									this.refactoredTextOption3 += `${elem.option3} `
									this.refactoredTextOption4 += `${elem.option4} `
								})
								console.log(this.refactoredTextOption1)
								console.log(this.refactoredTextOption2)
								console.log(this.refactoredTextOption3)
								console.log(this.refactoredTextOption4)
								// this.refactoredText = this.refactoredTextOption1

								this.refactorTextSetSuccess()

								if (this.textSource === 'heading') this.updateHeadingBtnDisabled = false
							}

						},
						error => {
							console.log(error)
							window.clearTimeout(idinterval)
							this.refactorTextSetError()
						},
					)
				}, interval)
			},
			error => {
				console.log(error)
				this.refactorTextSetError()
			},
		)
	}

	updateHeadingSetLoading() {
		this.updateHeadingBtnDisabled = true
		this.updatingHeading = true
		this.updateHeadingError = false
		this.updateHeadingSuccess = false
	}

	updateHeadingSetError() {
		this.updateHeadingBtnDisabled = false
		this.updatingHeading = false
		this.updateHeadingError = true
		this.updateHeadingSuccess = false
	}

	updateHeadingSetSuccess() {
		this.updateHeadingBtnDisabled = false
		this.updatingHeading = false
		this.updateHeadingError = false
		this.updateHeadingSuccess = true
	}

	updateHeading() {
		// console.log(selectedHeading)
		// console.log(text)
		this.updateHeadingSetLoading()
		this.refactoredText = this.tinymceEditorDiv.getEditorContent(this.refactoredTextEditorId)
		this.updateHeadingSub = this.dataService.updateHeading(this.selectedHeading, undefined, this.refactoredText)
		.subscribe(
			data => {
				console.log(data)
				this.updateHeadingSetSuccess()
			},
			error => {
				console.log(error)
				this.updateHeadingSetError()
			},
		)
	}

}